<p-fluid>
  <form [formGroup]="userForm" class="flex flex-col gap-4">
    <div class="flex flex-col gap-4">
      <span class="text-lg font-bold mb-2">
        {{ 'internal.users.editGeneralTitle' | translate }}
      </span>

      <p-floatlabel variant="on">
        <input pInputText formControlName="username" autocomplete="off" />
        <label>{{ 'internal.users.username' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <input pInputText formControlName="firstname" autocomplete="off" />
        <label>{{ 'internal.users.firstname' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <input pInputText formControlName="lastname" autocomplete="off" />
        <label>{{ 'internal.users.lastname' | translate }}</label>
      </p-floatlabel>

      <div class="w-full">
        <p-floatlabel variant="on">
          <p-password formControlName="password" autocomplete="off" />
          <label>{{ 'internal.users.password' | translate }}</label>
        </p-floatlabel>
        <small class="text-muted-color mt-1.5 opacity-75">
          {{ 'internal.users.leaveEmptyHint' | translate }}
        </small>
      </div>

      <p-floatlabel variant="on" class="w-full">
        <input pInputText formControlName="email" autocomplete="off" />
        <label>{{ 'internal.users.email' | translate }}</label>
      </p-floatlabel>

      <div class="w-full">
        <p-inputgroup>
          <button
            pButton
            [rounded]="true"
            [outlined]="true"
            (click)="generateRandomPin()"
            [disabled]="!userPermissions().has(pinPermission)"
          >
            <mat-icon>refresh</mat-icon>
          </button>
          <p-floatlabel variant="on">
            <input
              pInputText
              formControlName="userpin"
              size="4"
              inputmode="numeric"
              [minlength]="4"
              [maxlength]="4"
            />
            <label>{{ 'internal.users.pin' | translate }}</label>
          </p-floatlabel>
        </p-inputgroup>
        <small class="text-muted-color mt-1.5 opacity-75">
          {{ 'internal.users.leaveEmptyHint' | translate }}
        </small>
      </div>

      <p-togglebutton
        formControlName="active"
        fluid
        [onLabel]="'internal.users.active' | translate"
        [offLabel]="'internal.users.inactive' | translate"
      />

      <p-togglebutton
        formControlName="hidden"
        fluid
        [onLabel]="'internal.users.hidden' | translate"
        [offLabel]="'internal.users.visible' | translate"
      />
    </div>

    <div class="flex flex-col gap-4">
      <span class="text-lg font-bold mb-2 mt-4">{{
        'internal.users.editSchoolTitle' | translate
      }}</span>

      <p-floatlabel variant="on">
        <input pInputText formControlName="schoolclass" autocomplete="off" />
        <label>{{ 'internal.users.schoolclass' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on" class="w-full">
        <input pInputText formControlName="technikEmail" autocomplete="off" />
        <label>{{ 'internal.users.technikEmail' | translate }}</label>
      </p-floatlabel>

      <div class="w-full">
        <p-floatlabel variant="on">
          <p-password formControlName="technikEmailPassword" autocomplete="off" />
          <label>{{ 'internal.users.technikEmailPassword' | translate }}</label>
        </p-floatlabel>
        <small class="text-muted-color mt-1.5 opacity-75">
          {{ 'internal.users.leaveEmptyHint' | translate }}
        </small>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <span class="text-lg font-bold mb-2 mt-4">
        {{ 'internal.users.editPermissionsTitle' | translate }}
      </span>

      @for (group of getAllPermissionGroups(); track group) {
        <p-fieldset [toggleable]="true" [collapsed]="true">
          <ng-template #header>
            <div class="flex items-center gap-2">
              <p-checkbox
                class="z-10"
                [binary]="true"
                [disabled]="true"
                [ngModel]="allGroupPerms().includes(group)"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="editPermGroup(group, $event.checked)"
              />
              <span class="font-bold ml-2">{{ group }}</span>
            </div>
          </ng-template>
          <div class="flex flex-col mb-2">
            <div class="flex items-center gap-2 mb-4">
              <p-checkbox
                class="z-10"
                [binary]="true"
                [disabled]="!hasAnyGroupPerm(group)"
                [ngModel]="allGroupPerms().includes(group)"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="editPermGroup(group, $event.checked)"
              />
              <span class="font-bold ml-2">{{ 'internal.users.allPermissions' | translate }}</span>
            </div>

            @for (perm of this.getPermissionsByGroup(group); track perm) {
              <div
                class="flex items-center gap-2"
                tooltipPosition="top"
                [pTooltip]="
                  'permissions.' + group.toLowerCase() + '.' + perm.name + '.description'
                    | translate
                "
              >
                <p-checkbox
                  [ngModel]="userPermissions().has(perm)"
                  [ngModelOptions]="{ standalone: true }"
                  (onChange)="editPermission(perm, $event.checked)"
                  [binary]="true"
                  [disabled]="!hasPerm(perm.name) && perm.name != 'kiosk_mode'"
                />
                <label>
                  {{ 'permissions.' + group.toLowerCase() + '.' + perm.name + '.name' | translate }}
                </label>
              </div>
            }
          </div>
        </p-fieldset>
      }
    </div>
  </form>
</p-fluid>

<div class="flex justify-end gap-2 mt-6">
  @if (user._id != undefined && hasPerm('delete_users')) {
    <p-button [label]="'general.delete' | translate" severity="danger" (onClick)="deleteUser()" />
  }
  <p-button [label]="'general.cancel' | translate" severity="secondary" (onClick)="closeDialog()" />
  <p-button
    [label]="'general.save' | translate"
    [disabled]="!userForm.valid"
    (onClick)="closeDialog(true)"
  />
</div>
